import { render, staticRenderFns } from "./task-grid.vue?vue&type=template&id=173b8428&scoped=true&lang=pug&"
import script from "./task-grid.vue?vue&type=script&lang=js&"
export * from "./task-grid.vue?vue&type=script&lang=js&"
import style0 from "./task-grid.vue?vue&type=style&index=0&id=173b8428&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "173b8428",
  null
  
)

export default component.exports